import * as THREE from 'three';

export const createCubeFromBox3 = (
	box3,
	materialColor = 0x00ff00,
	wireframe = true,
) => {
	const boxSize = new THREE.Vector3();
	box3.getSize(boxSize);

	const boxCenter = new THREE.Vector3();
	box3.getCenter(boxCenter);

	const geometry = new THREE.BoxGeometry(boxSize.x, boxSize.y, boxSize.z);
	const material = new THREE.MeshBasicMaterial({
		color: materialColor,
		wireframe: wireframe,
	});

	const cube = new THREE.Mesh(geometry, material);
	cube.position.copy(boxCenter);

	return cube;
};

export const boxBoundSkinnedMeshGroup = (group) => {
	const vector = new THREE.Vector3();
	let box = new THREE.Box3().makeEmpty();

	group.traverse((mesh) => {
		if (!mesh.isMesh) return;
		if (!mesh.isSkinnedMesh) return;

		const position = mesh.geometry.attributes.position;
		for (let i = 0, il = position.count; i < il; i++) {
			vector.fromBufferAttribute(position, i);
			mesh.applyBoneTransform(i, vector);
			mesh.localToWorld(vector);
			box.expandByPoint(vector);
		}
	});
	return box;
};
